class PremiumController {
  constructor(Premium) {
    this.Premium = Premium;
    this.loadPremium();
  }
  showAddPremiumDialog() {
    const { Premium } = this;
    Premium.showAddDialog();
  }
  loadPremium(position) {
    const { Premium } = this;
    Premium.get(position).then((premiums) => {
      this.premiums = premiums;
    });
  }
  onPositionChange(position) {
    this.loadPremium(position);
  }
}
PremiumController.$inject = ['Premium'];
export default PremiumController;



// WEBPACK FOOTER //
// ./client/app/components/premium/premium.controller.js